import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { Company } from "../api/index";
import { selectedFeaturesChanged, loadCompaniesByCompanyValues, bootstrapValuesIndex } from "../actions";

export interface CompanyValueSearchState {
  selectedFeatures: number[];
  page: number;
  companies: Company[];
  isLoadingCompanies: boolean;
  isLoadedCompanies: boolean;
  errorMessage?: string;
  totalCompaniesCount: number;
}

const InitialState: CompanyValueSearchState = {
  selectedFeatures: [],
  page: 1,
  companies: [],
  isLoadingCompanies: false,
  isLoadedCompanies: false,
  totalCompaniesCount: 0,
};

const searchReducer = withImmer(reducerWithInitialState<CompanyValueSearchState>(InitialState))
  .case(bootstrapValuesIndex, (state, result) => {
    const { selected_features, total_companies_count, ...rest } = result;
    Object.assign(state, rest, {
      selectedFeatures: selected_features,
      totalCompaniesCount: total_companies_count,
    });
    return state;
  })
  .case(selectedFeaturesChanged, (state, result) => {
    state.selectedFeatures = result.selectedFeatures;
    return state;
  })
  .case(loadCompaniesByCompanyValues.started, state => {
    state.isLoadingCompanies = true;
    return state;
  })
  .case(loadCompaniesByCompanyValues.done, (state, { result }) => {
    Object.assign(state, {
      companies: result.page > 1 ? state.companies.concat(result.companies) : result.companies,
      isLoadingCompanies: false,
      isLoadedCompanies: true,
      page: result.page,
      totalCompaniesCount: result.total_companies_count,
    });
    return state;
  })
  .case(loadCompaniesByCompanyValues.failed, (state, err) => {
    Object.assign(state, {
      isLoadingCompanies: false,
      isLoadedCompanies: false,
      errorMessage: err.error.message,
    });
    return state;
  });

export default searchReducer;



// WEBPACK FOOTER //
// ./frontend/src/company_values/reducers/search.ts